// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"f739afc4","129":"823850e6","146":"ae4f80e0","165":"ecaa6d58","287":"37c0a1a9","304":"b769f76d","433":"475bb0cb","528":"deb51899","635":"8a9ade0e","691":"454c03ff"}[chunkId] + ".chunk.js";
};